module.exports = __webpack_public_path__ + "static/img/药店管理@2x1.d197199e.png";